import { Button } from '@/atoms/Button'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { ParagraphSM } from '@/atoms/Text'
import { ReactFCC } from '@/types/react'
import { useTranslate } from '@/utils/translate/translate-client'

export type UploadErrorType = {
  type: string
  message: string
}

interface UploadErrorMessageProps {
  error: UploadErrorType
  dismiss: () => void
}

export const UploadErrorMessage: ReactFCC<UploadErrorMessageProps> = ({ error, dismiss }) => {
  const { t } = useTranslate('guild-create')

  return (
    <div className="flex select-none flex-col items-center gap-1">
      <CloseIcon size={48} color="error-500" />
      <ParagraphSM>{error?.type}</ParagraphSM>
      <ParagraphSM color="core-gray-600">{error?.message}</ParagraphSM>
      <Button className="mt-4" variant="black" onClick={dismiss}>
        {t('dismiss', 'Dismiss')}
      </Button>
    </div>
  )
}
